
import {
  PreparationDocumentDto,
  CreatePreparationDocumentDto,
  UpdatePreparationDocumentDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type PreparationDocumentsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  search?: string
  compoundId?: string
}

class PreparationDocumentService extends BaseCrudService<
  PreparationDocumentDto,
  CreatePreparationDocumentDto,
  UpdatePreparationDocumentDto,
  PreparationDocumentsFilters
> {
  constructor() {
    super('preparation-document', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const preparationDocumentService = new PreparationDocumentService()
